export default {"src":"/_next/static/media/automated-audit-trails.9ebb47ed.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};